import _ from "lodash";
import { FEEDERLISTS, KEYWORD } from "../_constants/actionConstants";

const initialState = {
  projKeywordLists: {}, // Normalized by projectId
  keywordList: [],
  openKeywordDetails: {}, // Normalized by projectId, then by keywordId
  miscSessionData: {}, // Normalized by tabId
  fetching: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case KEYWORD.ADD:
    case KEYWORD.DELETE:
    case KEYWORD.EDIT:
    case KEYWORD.FETCH_DETAILS:
    case KEYWORD.FETCH_ALL:
    case KEYWORD.FETCH_ALL_FOR_PROJECT:
    case KEYWORD.GENERIC_REQUEST:
      return { ...state, fetching: true };

    case KEYWORD.GENERIC_REQUEST_FULFILLED:
    case KEYWORD.GENERIC_REQUEST_REJECTED:
      return { ...state, fetching: false };

    case KEYWORD.ADD_FULFILLED:
    case KEYWORD.DELETE_FULFILLED:
    case KEYWORD.FETCH_ALL_FOR_PROJECT_FULFILLED:
    case FEEDERLISTS.FETCH_FULFILLED: {
      const { projectId, projKeywordList } = action;
      if (!projectId) return { ...state, fetching: false };
      return {
        ...state,
        fetching: false,
        projKeywordLists: {
          ...state.projKeywordLists,
          [projectId]: projKeywordList,
        },
      };
    }

    case KEYWORD.FETCH_DETAILS_FULFILLED: {
      const { projectId, keywordId, keywordDetails } = action;
      if (!projectId || !keywordId) return { ...state, fetching: false };

      return {
        ...state,
        fetching: false,
        openKeywordDetails: {
          ...state.openKeywordDetails,
          [projectId]: {
            ...state.openKeywordDetails[projectId],
            [keywordId]: keywordDetails,
          },
        },
      };
    }

    case KEYWORD.CLEAR_DETAILS: {
      const { projectId, keywordId } = action;
      if (
        !projectId ||
        !keywordId ||
        !(projectId in state.openKeywordDetails) ||
        !(keywordId in state.openKeywordDetails[projectId])
      )
        return { ...state, fetching: false };

      let openKeywordDetails = _.cloneDeep(state.openKeywordDetails);
      delete openKeywordDetails[projectId][keywordId];

      return { ...state, openKeywordDetails };
    }

    default:
      return state;
  }
};
